// Archivo que contiene una coleccion de iconos customs que no existen en React-Icons
import { KeysOf, PropsWithClassName } from '@/types';
import { COLORS } from '@/utils';

const variantColors = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  quaternary: 'quaternary',
  premium: 'premium',
} as const;

type VariantKeys = KeysOf<typeof variantColors>;

const getIconColorVariant = (variant: VariantKeys) => {
  if (variant === variantColors.primary) {
    return '#3366FF';
  } else if (variant === variantColors.secondary) {
    return '#333333';
  } else if (variant === variantColors.quaternary) {
    return '#ffffff';
  } else if (variant === variantColors.premium) {
    return '#FEF6BD';
  }

  return '#717077';
};

type IconProps = {
  variant: VariantKeys;
  context?: 'menu' | 'page';
};

export const BellIcon = ({ className }: PropsWithClassName) => {
  return (
    <div className={className}>
      <svg
        fill="none"
        height="100%"
        viewBox="0 0 19 19"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_41_93055)">
          <path
            d="M17.1459 14.8172C16.6661 14.3894 16.2461 13.8991 15.8971 13.3593C15.516 12.6143 15.2877 11.8006 15.2254 10.9661V8.50823C15.2287 7.1975 14.7532 5.93067 13.8883 4.94577C13.0234 3.96087 11.8287 3.32569 10.5285 3.15958V2.51774C10.5285 2.34158 10.4585 2.17263 10.334 2.04806C10.2094 1.9235 10.0404 1.85352 9.86428 1.85352C9.68811 1.85352 9.51917 1.9235 9.3946 2.04806C9.27003 2.17263 9.20005 2.34158 9.20005 2.51774V3.16953C7.91153 3.34762 6.7312 3.98664 5.87768 4.96823C5.02416 5.94982 4.5553 7.20746 4.55792 8.50823V10.9661C4.4956 11.8006 4.26724 12.6143 3.88623 13.3593C3.54336 13.8979 3.13005 14.3881 2.65728 14.8172C2.60421 14.8638 2.56167 14.9212 2.5325 14.9855C2.50334 15.0499 2.4882 15.1197 2.48811 15.1903V15.867C2.48811 15.9989 2.54053 16.1255 2.63384 16.2188C2.72715 16.3121 2.8537 16.3645 2.98566 16.3645H16.8175C16.9495 16.3645 17.076 16.3121 17.1693 16.2188C17.2627 16.1255 17.3151 15.9989 17.3151 15.867V15.1903C17.315 15.1197 17.2999 15.0499 17.2707 14.9855C17.2415 14.9212 17.199 14.8638 17.1459 14.8172ZM3.52302 15.3694C3.98594 14.9222 4.39353 14.4211 4.73704 13.8768C5.21698 12.977 5.49701 11.9841 5.55799 10.9661V8.50823C5.53826 7.92512 5.63607 7.34401 5.8456 6.79948C6.05513 6.25496 6.37209 5.75817 6.77761 5.3387C7.18313 4.91922 7.66891 4.58564 8.20604 4.35782C8.74316 4.12999 9.32064 4.01258 9.90408 4.01258C10.4875 4.01258 11.065 4.12999 11.6021 4.35782C12.1393 4.58564 12.625 4.91922 13.0306 5.3387C13.4361 5.75817 13.753 6.25496 13.9626 6.79948C14.1721 7.34401 14.2699 7.92512 14.2502 8.50823V10.9661C14.3112 11.9841 14.5912 12.977 15.0711 13.8768C15.4146 14.4211 15.8222 14.9222 16.2851 15.3694H3.52302Z"
            fill="white"
          />
          <path
            d="M9.92647 18.027C10.2399 18.0198 10.5407 17.9019 10.7756 17.6943C11.0105 17.4867 11.1644 17.2027 11.2101 16.8926H8.59304C8.64005 17.2112 8.80118 17.5018 9.04646 17.7105C9.29174 17.9192 9.60447 18.0316 9.92647 18.027Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_41_93055">
            <rect
              fill="white"
              height="17.9118"
              transform="translate(0.970588 0.970703)"
              width="17.9118"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const PremiumIcon = ({ variant, context = 'menu' }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 25 24"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9492 7C15.8552 7 14.3382 8.567 12.9482 10.346C11.5582 8.567 10.0422 7 7.94923 7C5.19223 7 2.94923 9.243 2.94923 12C2.94763 12.6561 3.07569 13.3061 3.32608 13.9126C3.57646 14.5191 3.94422 15.0701 4.40823 15.534C4.87041 16 5.42053 16.3695 6.02668 16.6212C6.63283 16.8729 7.28292 17.0016 7.93923 17H7.95123C10.0402 16.995 11.5562 15.428 12.9472 13.649C14.3382 15.431 15.8552 17 17.9492 17C20.7062 17 22.9492 14.757 22.9492 12C22.9492 9.243 20.7062 7 17.9492 7ZM7.94723 15L7.93923 16V15C7.14023 15 6.38923 14.688 5.82523 14.122C5.40723 13.7016 5.12297 13.1669 5.00827 12.5852C4.89356 12.0035 4.95354 11.4009 5.18063 10.8533C5.40773 10.3057 5.7918 9.83746 6.28447 9.50767C6.77713 9.17788 7.35637 9.00124 7.94923 9C9.27923 9 10.5092 10.438 11.6952 11.998C10.5072 13.557 9.27723 14.997 7.94723 15ZM17.9492 15C16.6192 15 15.3882 13.56 14.2002 11.998C15.3872 10.438 16.6172 9 17.9492 9C19.6032 9 20.9492 10.346 20.9492 12C20.9492 13.654 19.6032 15 17.9492 15Z"
        fill={context === 'menu' ? color : COLORS['gdt-status'].yellow.DEFAULT}
      />
    </svg>
  );
};

export const PremiumCrown = () => {
  return (
    <svg
      fill="none"
      height="11"
      viewBox="0 0 12 11"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.35755 9.45947H3.67859C3.46953 9.45947 3.23558 9.29521 3.16589 9.09611L1.10515 3.33202C0.811474 2.50573 1.15493 2.25187 1.86175 2.75959L3.80303 4.14835C4.12657 4.37234 4.49492 4.25786 4.63429 3.89449L5.51035 1.55998C5.7891 0.813339 6.25202 0.813339 6.53077 1.55998L7.40683 3.89449C7.5462 4.25786 7.91455 4.37234 8.23311 4.14835L10.0549 2.84919C10.8314 2.29169 11.2048 2.57542 10.8862 3.47637L8.87523 9.10606C8.80056 9.29521 8.56661 9.45947 8.35755 9.45947Z"
        stroke={COLORS['gdt-status'].yellow.DEFAULT}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
      />
    </svg>
  );
};

export const MedalIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="19"
      viewBox="0 0 18 19"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_645_2088)">
        <path
          clipRule="evenodd"
          d="M9 2C6.51472 2 4.5 4.01472 4.5 6.5C4.5 8.98528 6.51472 11 9 11C11.4853 11 13.5 8.98528 13.5 6.5C13.5 4.01472 11.4853 2 9 2ZM3 6.5C3 3.18629 5.68629 0.5 9 0.5C12.3137 0.5 15 3.18629 15 6.5C15 9.81371 12.3137 12.5 9 12.5C5.68629 12.5 3 9.81371 3 6.5Z"
          fill={color}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M11.7439 10.1665C12.1545 10.112 12.5315 10.4007 12.586 10.8114L13.4935 17.6514C13.5314 17.9368 13.4025 18.2188 13.1618 18.3769C12.921 18.535 12.6111 18.5413 12.3641 18.3931L9.00002 16.3746L5.63589 18.3931C5.38894 18.5413 5.07895 18.535 4.83824 18.3768C4.59753 18.2187 4.46863 17.9367 4.50655 17.6512L5.41405 10.8187C5.46858 10.4081 5.84566 10.1195 6.25627 10.174C6.66687 10.2286 6.95553 10.6056 6.90099 11.0162L6.19835 16.3064L8.61415 14.8569C8.85166 14.7144 9.14838 14.7144 9.38589 14.8569L11.8019 16.3065L11.099 11.0086C11.0446 10.598 11.3333 10.221 11.7439 10.1665Z"
          fill={color}
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_645_2088">
          <rect
            fill="white"
            height="18"
            transform="translate(0 0.5)"
            width="18"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TDAIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);

  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 20 21"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.67953 6.01759C10.0011 6.01678 10.3196 6.0795 10.6169 6.20216C10.9141 6.32482 11.1842 6.50499 11.4116 6.73233C11.639 6.95967 11.8193 7.2297 11.942 7.52691C12.0648 7.82412 12.1276 8.14265 12.1269 8.46421C12.1269 9.85746 11.0352 10.9492 9.67953 10.9492C9.35315 10.9495 9.02991 10.8854 8.72833 10.7606C8.42674 10.6358 8.15273 10.4528 7.92198 10.222C7.69123 9.99116 7.50827 9.71709 7.38358 9.41547C7.25889 9.11385 7.19491 8.79059 7.19531 8.46421C7.19531 7.10932 8.32464 6.01759 9.67953 6.01759ZM10.8848 7.26276C10.5614 6.95004 10.1294 6.77464 9.67953 6.77328C8.73817 6.77328 7.94794 7.52591 7.94794 8.46728C7.94734 8.69484 7.99171 8.92028 8.07852 9.13064C8.16532 9.341 8.29285 9.53213 8.45376 9.69305C8.61467 9.85396 8.8058 9.98148 9.01616 10.0683C9.22652 10.1551 9.45196 10.1995 9.67953 10.1989C10.6209 10.1989 11.3735 9.44623 11.3735 8.46728C11.365 8.01919 11.1909 7.59013 10.8848 7.26276V7.26276Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
      <path
        d="M6.44204 15.2786C6.43556 15.3764 6.39379 15.4685 6.3245 15.5378C6.25521 15.6071 6.16312 15.6489 6.06534 15.6553C5.96557 15.6551 5.86995 15.6154 5.79947 15.5447C5.72899 15.4741 5.68941 15.3784 5.68941 15.2786C5.68531 14.7089 5.80056 14.1447 6.02775 13.6222C5.53827 12.9448 4.74805 12.5681 3.87957 12.5681C3.52319 12.5666 3.17004 12.6357 2.84049 12.7713C2.51095 12.907 2.21153 13.1066 1.95953 13.3586C1.70753 13.6106 1.50793 13.91 1.37225 14.2396C1.23658 14.5691 1.16751 14.9223 1.16903 15.2786C1.17133 15.3295 1.16329 15.3803 1.14542 15.4279C1.12754 15.4756 1.10019 15.5191 1.06502 15.5559C1.02985 15.5927 0.98759 15.622 0.940788 15.642C0.893985 15.662 0.843614 15.6723 0.792714 15.6723C0.741814 15.6723 0.691443 15.662 0.64464 15.642C0.597838 15.622 0.555575 15.5927 0.520405 15.5559C0.485235 15.5191 0.457886 15.4756 0.440011 15.4279C0.422135 15.3803 0.414103 15.3295 0.416399 15.2786C0.416464 14.58 0.62779 13.8977 1.02263 13.3213C1.41748 12.7449 1.97738 12.3014 2.62884 12.049C3.28029 11.7966 3.99285 11.7471 4.67297 11.9069C5.35308 12.0668 5.96895 12.4286 6.43974 12.9448C6.80468 12.4269 7.29007 12.0055 7.85409 11.717C8.41811 11.4284 9.04384 11.2813 9.67735 11.2884C10.3095 11.2897 10.9324 11.4405 11.4951 11.7283C12.0579 12.0162 12.5447 12.433 12.9157 12.9448C13.2374 12.585 13.6322 12.2981 14.0737 12.1033C14.5153 11.9086 14.9933 11.8104 15.4759 11.8155C17.3586 11.8155 18.9022 13.3591 18.9022 15.2786C18.9022 15.3281 18.8925 15.3771 18.8736 15.4228C18.8546 15.4685 18.8269 15.51 18.7919 15.545C18.7569 15.58 18.7154 15.6077 18.6697 15.6267C18.624 15.6456 18.575 15.6553 18.5255 15.6553C18.4278 15.6487 18.3358 15.6069 18.2666 15.5376C18.1973 15.4684 18.1555 15.3764 18.1488 15.2786C18.1514 14.9251 18.0842 14.5746 17.9513 14.2471C17.8183 13.9195 17.6221 13.6214 17.3739 13.3697C17.1257 13.118 16.8303 12.9176 16.5046 12.7801C16.179 12.6425 15.8294 12.5705 15.4759 12.5681C15.0553 12.5637 14.6395 12.6566 14.2607 12.8394C13.8819 13.0223 13.5506 13.2902 13.2924 13.6222C13.5203 14.1445 13.6358 14.7089 13.6315 15.2786C13.6315 15.3786 13.5918 15.4744 13.5212 15.545C13.4506 15.6157 13.3547 15.6553 13.2548 15.6553C13.1571 15.6487 13.0651 15.6069 12.9958 15.5376C12.9266 15.4684 12.8848 15.3764 12.8781 15.2786C12.8983 14.8434 12.83 14.4086 12.6773 14.0005C12.5247 13.5924 12.2908 13.2195 11.9899 12.9044C11.6891 12.5892 11.3274 12.3384 10.9268 12.167C10.5262 11.9956 10.095 11.9073 9.65932 11.9073C9.22361 11.9073 8.79243 11.9956 8.39184 12.167C7.99125 12.3384 7.62958 12.5892 7.32871 12.9044C7.02783 13.2195 6.79398 13.5924 6.64132 14.0005C6.48866 14.4086 6.42034 14.8434 6.4405 15.2786H6.44204Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
      <path
        d="M3.88171 7.9372C3.69378 7.9371 3.50768 7.97404 3.33403 8.04591C3.16039 8.11778 3.00262 8.22317 2.86973 8.35606C2.73684 8.48894 2.63145 8.64672 2.55958 8.82036C2.48771 8.994 2.45077 9.18011 2.45087 9.36804C2.45087 10.1207 3.09149 10.7613 3.88171 10.7613C4.06479 10.7617 4.24614 10.7259 4.41536 10.6561C4.58458 10.5862 4.73833 10.4836 4.86779 10.3541C4.99724 10.2247 5.09985 10.0709 5.16973 9.90169C5.2396 9.73247 5.27536 9.55112 5.27496 9.36804C5.27496 8.57705 4.6727 7.9372 3.88171 7.9372ZM3.88171 7.18457C5.08623 7.18457 6.02989 8.16353 6.02989 9.36804C6.02989 9.93777 5.80357 10.4842 5.4007 10.887C4.99784 11.2899 4.45144 11.5162 3.88171 11.5162C2.6772 11.5162 1.69824 10.5373 1.69824 9.36804C1.69905 8.78934 1.92941 8.23459 2.33876 7.82553C2.7481 7.41647 3.30301 7.18651 3.88171 7.1861V7.18457Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
      <path
        d="M15.4774 7.9372C15.2896 7.9372 15.1035 7.97421 14.93 8.04613C14.7564 8.11805 14.5987 8.22345 14.4659 8.35633C14.3331 8.48921 14.2278 8.64695 14.156 8.82054C14.0842 8.99413 14.0472 9.18018 14.0473 9.36804C14.0473 10.1207 14.6872 10.7613 15.4774 10.7613C15.8452 10.7557 16.1964 10.6072 16.4565 10.3471C16.7166 10.087 16.8651 9.73582 16.8707 9.36804C16.8707 8.57705 16.2308 7.9372 15.4774 7.9372ZM15.4774 7.18457C16.6451 7.18457 17.6256 8.16353 17.6256 9.36804C17.6202 9.9361 17.3921 10.4794 16.9904 10.8811C16.5887 11.2828 16.0455 11.5108 15.4774 11.5162C14.2729 11.5162 13.2939 10.5373 13.2939 9.36804C13.2948 8.78934 13.5251 8.23459 13.9345 7.82553C14.3438 7.41647 14.8987 7.18651 15.4774 7.1861V7.18457Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
    </svg>
  );
};

export const MiniLigasIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 17 17"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_645_2079)">
        <path d="M17 0H0V17H17V0Z" fill="white" fillOpacity="0.01" />
        <path
          d="M8.50033 15.5827C12.4123 15.5827 15.5837 12.4114 15.5837 8.49935C15.5837 4.58733 12.4123 1.41602 8.50033 1.41602C4.58831 1.41602 1.41699 4.58733 1.41699 8.49935C1.41699 12.4114 4.58831 15.5827 8.50033 15.5827Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M10.6586 2.30176L8.52539 3.84556V5.38936L11.2681 7.55069L12.7919 6.93317L13.7061 4.46308"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M6.39202 2.30177L8.52526 3.84558V5.38938L5.78253 7.5507L4.25879 6.93318L3.34454 4.4631"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M2.12598 7.85988L4.25921 6.93359L5.78295 7.55112L6.6972 10.9475L5.78295 12.1825H3.04022"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M5.7832 14.3436V12.1823L6.69745 10.9473H10.3544L11.2687 12.1823V14.3436"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M14.0115 12.1825H11.2687L10.3545 10.9475L11.2687 7.55112L12.7925 6.93359L15.2305 8.16864"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_645_2079">
          <rect fill="white" height="17" width="17" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CopaDeAmigosIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="19"
      viewBox="0 0 18 19"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3922 11.189L11.3922 11.1891C10.7898 11.7914 9.99046 12.1219 9.14062 12.1219H8.85938C8.0095 12.1219 7.20839 11.7914 6.60787 11.1891L6.60782 11.1891C6.00548 10.5867 5.675 9.78733 5.675 8.9375V3.78437H12.325V8.9375C12.325 9.78738 11.9945 10.5885 11.3922 11.189ZM15.2578 3.2625H13.6906V2.60938C13.6906 2.50442 13.605 2.41875 13.5 2.41875H4.5C4.39504 2.41875 4.30938 2.50442 4.30938 2.60938V3.2625H2.74219C2.5238 3.2625 2.31435 3.34925 2.15993 3.50368C2.0055 3.6581 1.91875 3.86755 1.91875 4.08594V6.6875C1.91875 8.13584 2.97301 9.34149 4.35354 9.57848C4.64159 11.6116 6.27084 13.2115 8.31719 13.4557V15.2104H4.92188C4.58313 15.2104 4.30938 15.4841 4.30938 15.8229V16.3906C4.30938 16.4956 4.39504 16.5813 4.5 16.5813H13.5C13.605 16.5813 13.6906 16.4956 13.6906 16.3906V15.8229C13.6906 15.4841 13.4169 15.2104 13.0781 15.2104H9.68281V13.4557C11.7292 13.2115 13.3584 11.6116 13.6465 9.57848C15.027 9.34149 16.0813 8.13584 16.0813 6.6875V4.08594C16.0813 3.86755 15.9945 3.6581 15.8401 3.50368C15.6856 3.34925 15.4762 3.2625 15.2578 3.2625ZM3.28437 6.68748V4.62812H4.30938V8.15729C4.02027 8.05072 3.76846 7.86104 3.58609 7.61142C3.39014 7.34321 3.28448 7.01967 3.28437 6.6875C3.28437 6.68749 3.28437 6.68749 3.28437 6.68748ZM14.7156 6.6875C14.7156 7.36159 14.2887 7.93741 13.6906 8.15737V4.62812H14.7156V6.6875Z"
        fill={color}
        stroke={color}
        strokeWidth="0.1"
      />
    </svg>
  );
};

export const FechaDeOroIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="23"
      viewBox="0 0 22 23"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4375 3.25C13.2048 3.25 12.0876 3.481 11.2145 3.91619C10.3421 4.35137 9.625 5.06019 9.625 6V8.75C9.625 8.83869 9.65456 8.92463 9.66831 9.00781C8.98014 8.83294 8.27253 8.74631 7.5625 8.75C6.32981 8.75 5.21262 8.981 4.3395 9.41619C3.46706 9.85137 2.75 10.5602 2.75 11.5V17C2.75 17.9398 3.46706 18.6486 4.34019 19.0838C5.21263 19.519 6.32981 19.75 7.5625 19.75C8.79519 19.75 9.91237 19.519 10.7855 19.0838C11.6572 18.6486 12.375 17.9398 12.375 17V16.7209C13.0475 16.9027 13.7408 16.9965 14.4375 17C15.6702 17 16.7874 16.769 17.6605 16.3338C18.5322 15.8986 19.25 15.1898 19.25 14.25V6C19.25 5.06019 18.5329 4.35137 17.6598 3.91619C16.7881 3.481 15.6709 3.25 14.4375 3.25ZM14.4375 4.625C15.4846 4.625 16.4168 4.8505 17.0369 5.16194C17.6578 5.47338 17.875 5.80131 17.875 6C17.875 6.19937 17.6578 6.52662 17.0369 6.83806C16.4175 7.1495 15.4846 7.375 14.4375 7.375C13.3904 7.375 12.4582 7.1495 11.8381 6.83806C11.2172 6.52662 11 6.19869 11 6C11 5.80063 11.2172 5.47338 11.8381 5.16194C12.4575 4.8505 13.3904 4.625 14.4375 4.625ZM11 7.95525C11.0722 7.99512 11.1396 8.04669 11.2152 8.08381C12.0876 8.519 13.2048 8.75 14.4375 8.75C15.6702 8.75 16.7874 8.519 17.6605 8.08381C17.7354 8.04669 17.8028 7.99512 17.875 7.95525V8.75C17.875 8.94937 17.6578 9.27662 17.0369 9.58806C16.4168 9.8995 15.4846 10.125 14.4375 10.125C13.3904 10.125 12.4582 9.8995 11.8381 9.58806C11.2172 9.27662 11 8.94869 11 8.75V7.95525ZM7.5625 10.125C8.60956 10.125 9.54181 10.3505 10.1619 10.6619C10.7828 10.9734 11 11.3013 11 11.5C11 11.6994 10.7828 12.0266 10.1619 12.3381C9.54181 12.6495 8.60956 12.875 7.5625 12.875C6.51544 12.875 5.58319 12.6495 4.96306 12.3381C4.34225 12.0266 4.125 11.6987 4.125 11.5C4.125 11.3006 4.34225 10.9734 4.96306 10.6619C5.5825 10.3505 6.51544 10.125 7.5625 10.125ZM17.875 10.7052V11.5C17.875 11.6994 17.6578 12.0266 17.0369 12.3381C16.4168 12.6495 15.4846 12.875 14.4375 12.875C13.7372 12.8788 13.0408 12.7699 12.375 12.5526V11.5C12.375 11.4113 12.3454 11.3254 12.3317 11.2422C12.9711 11.4086 13.6799 11.5 14.4375 11.5C15.6702 11.5 16.7874 11.269 17.6605 10.8338C17.7354 10.7967 17.8028 10.7451 17.875 10.7052V10.7052ZM4.125 13.4552C4.19719 13.4951 4.26456 13.5467 4.34019 13.5838C5.21263 14.019 6.32981 14.25 7.5625 14.25C8.79519 14.25 9.91237 14.019 10.7855 13.5838C10.8604 13.5467 10.9278 13.4951 11 13.4552V14.25C11 14.4494 10.7828 14.7766 10.1619 15.0881C9.54181 15.3995 8.60956 15.625 7.5625 15.625C6.51544 15.625 5.58319 15.3995 4.96306 15.0881C4.34225 14.7766 4.125 14.4487 4.125 14.25V13.4552ZM17.875 13.4552V14.25C17.875 14.4494 17.6578 14.7766 17.0369 15.0881C16.4168 15.3995 15.4846 15.625 14.4375 15.625C13.6558 15.625 12.9498 15.515 12.375 15.3239V13.9922C13.0061 14.1586 13.6936 14.25 14.4375 14.25C15.6702 14.25 16.7874 14.019 17.6605 13.5838C17.7354 13.5467 17.8028 13.4951 17.875 13.4552V13.4552ZM4.125 16.2052C4.19719 16.2451 4.26456 16.2967 4.34019 16.3338C5.21263 16.769 6.32981 17 7.5625 17C8.79519 17 9.91237 16.769 10.7855 16.3338C10.8604 16.2967 10.9278 16.2451 11 16.2052V17C11 17.1994 10.7828 17.5266 10.1619 17.8381C9.54181 18.1495 8.60956 18.375 7.5625 18.375C6.51544 18.375 5.58319 18.1495 4.96306 17.8381C4.34225 17.5266 4.125 17.1987 4.125 17V16.2052Z"
        fill={color}
      />
    </svg>
  );
};

export const TorneoDeEscuelasIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 19 21"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4163 8.00033L9.49967 4.66699L1.58301 8.00033L9.49967 11.3337L17.4163 8.00033ZM17.4163 8.00033V13.0003"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4.75 9.33398V13.834C4.75 14.497 5.25045 15.1329 6.14124 15.6018C7.03204 16.0706 8.24022 16.334 9.5 16.334C10.7598 16.334 11.968 16.0706 12.8588 15.6018C13.7496 15.1329 14.25 14.497 14.25 13.834V9.33398"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const Desafio1a1Icon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 21 21"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6742 4.57354C12.3099 4.57617 11.9483 4.59389 11.5664 4.69626C11.1503 4.80921 10.7555 4.98943 10.3976 5.22979C9.89494 4.93448 9.408 4.69167 8.94141 4.63458C8.36194 4.56304 7.82381 4.60176 7.19841 4.61489C6.45684 4.62998 5.97319 5.00864 5.18831 5.31183C4.40409 5.6137 3.39412 5.90639 1.96875 5.90639H1.3125V12.2228L1.68197 12.4072L2.89144 13.0024L7.19841 17.8009L7.21875 17.8213C7.71094 18.3082 8.37506 18.429 8.96175 18.3955C9.54909 18.3627 10.1003 18.1907 10.5407 17.9243C11.51 17.3396 14.1501 15.504 14.1501 15.504L14.2118 15.4627L14.2531 15.422C14.5655 15.1116 14.7223 14.733 14.8273 14.3353L17.3493 13.0635L19.236 12.4282L19.6875 12.2838V5.90639H19.0312C17.9281 5.91393 16.8342 5.70479 15.8117 5.29083C15.0268 4.98436 14.5504 4.60964 13.8009 4.59389C13.4006 4.58601 13.0371 4.57092 12.6735 4.57354H12.6742ZM12.6938 5.88604C12.9892 5.88342 13.3304 5.89917 13.7609 5.90639C13.8298 5.90901 14.4605 6.17808 15.3398 6.52195C16.0834 6.81398 17.1163 7.0732 18.375 7.1572V11.3408L16.8571 11.854H16.8164L16.7751 11.8737L14.7866 12.879C14.6811 12.5745 14.5135 12.2952 14.2944 12.0587L14.2531 11.997L11.464 8.57273L11.0539 8.05954L10.5407 8.4697L8.77734 9.90558C8.18541 10.3157 7.70569 10.1976 7.21875 9.96726C7.07766 9.90033 7.08553 9.87998 6.97266 9.8032L9.96712 7.32126L10.0078 7.28058C10.897 6.39858 11.4437 6.09342 11.9149 5.96808C12.1511 5.90376 12.3998 5.88867 12.6945 5.88604H12.6938ZM8.12175 5.90639C8.34071 5.89814 8.55997 5.90493 8.778 5.92673C8.94994 5.94708 9.14484 6.09342 9.31153 6.15248C9.24459 6.21417 9.19603 6.24961 9.12647 6.31654L9.08578 6.35789L5.49675 9.3307L4.94288 9.7822L5.43506 10.2947C5.43506 10.2947 5.90953 10.8079 6.64519 11.1564C7.38084 11.5049 8.51681 11.7024 9.53662 10.9923L9.57797 10.951L10.8491 9.90558L13.2694 12.879L13.2897 12.9204L13.3101 12.9401C13.7432 13.3686 13.7333 14.0426 13.3101 14.479C13.3048 14.4836 13.3153 14.4941 13.3101 14.4987C13.3048 14.502 13.2182 14.5531 13.2077 14.561L12.346 13.3916L11.2796 14.1712L12.1209 15.2986C11.7797 15.5296 11.6261 15.6504 11.2593 15.8939L10.3779 14.7041L9.31087 15.4837L10.1522 16.6111C10.0774 16.6571 9.92381 16.7601 9.86475 16.7962C9.65737 16.9215 9.25706 17.0626 8.90072 17.083C8.56537 17.1014 8.30878 17.0239 8.18344 16.9189L8.16309 16.8986L3.77409 12.0384L3.69206 11.9354L2.625 11.4025V7.1572C3.87844 7.07517 4.91925 6.82645 5.66016 6.54229C6.53691 6.20629 7.16297 5.92936 7.23909 5.92673L8.12109 5.90639H8.12175Z"
        fill={color}
      />
    </svg>
  );
};

export const MiPerfilIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="19"
      viewBox="0 0 18 19"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M3.34835 12.0984C4.05161 11.3951 5.00544 11 6 11H12C12.9946 11 13.9484 11.3951 14.6517 12.0984C15.3549 12.8016 15.75 13.7555 15.75 14.75V16.25C15.75 16.6642 15.4142 17 15 17C14.5858 17 14.25 16.6642 14.25 16.25V14.75C14.25 14.1533 14.0129 13.581 13.591 13.159C13.169 12.7371 12.5967 12.5 12 12.5H6C5.40326 12.5 4.83097 12.7371 4.40901 13.159C3.98705 13.581 3.75 14.1533 3.75 14.75V16.25C3.75 16.6642 3.41421 17 3 17C2.58579 17 2.25 16.6642 2.25 16.25V14.75C2.25 13.7555 2.64509 12.8016 3.34835 12.0984Z"
        fill={color}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9 3.50002C7.75736 3.50002 6.75 4.50737 6.75 5.75002C6.75 6.99266 7.75736 8.00001 9 8.00001C10.2426 8.00001 11.25 6.99266 11.25 5.75002C11.25 4.50737 10.2426 3.50002 9 3.50002ZM5.25 5.75002C5.25 3.67895 6.92893 2.00002 9 2.00002C11.0711 2.00002 12.75 3.67895 12.75 5.75002C12.75 7.82108 11.0711 9.50001 9 9.50001C6.92893 9.50001 5.25 7.82108 5.25 5.75002Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

export const SalirIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 16 17"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M9.33334 2.49999C9.33334 2.13181 9.63182 1.83333 10 1.83333H12.6667C13.1971 1.83333 13.7058 2.04404 14.0809 2.41911C14.456 2.79419 14.6667 3.30289 14.6667 3.83333V13.1667C14.6667 13.6971 14.456 14.2058 14.0809 14.5809C13.7058 14.9559 13.1971 15.1667 12.6667 15.1667H10C9.63182 15.1667 9.33334 14.8682 9.33334 14.5C9.33334 14.1318 9.63182 13.8333 10 13.8333H12.6667C12.8435 13.8333 13.0131 13.7631 13.1381 13.6381C13.2631 13.513 13.3333 13.3435 13.3333 13.1667V3.83333C13.3333 3.65652 13.2631 3.48695 13.1381 3.36192C13.0131 3.2369 12.8435 3.16666 12.6667 3.16666H10C9.63182 3.16666 9.33334 2.86818 9.33334 2.49999Z"
        fill={color}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6.19526 4.69526C6.45561 4.43491 6.87772 4.43491 7.13807 4.69526L10.4714 8.0286C10.7318 8.28894 10.7318 8.71105 10.4714 8.9714L7.13807 12.3047C6.87772 12.5651 6.45561 12.5651 6.19526 12.3047C5.93491 12.0444 5.93491 11.6223 6.19526 11.3619L9.05719 8.5L6.19526 5.63807C5.93491 5.37772 5.93491 4.95561 6.19526 4.69526Z"
        fill={color}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M1.33334 8.49999C1.33334 8.13181 1.63182 7.83333 2.00001 7.83333H10C10.3682 7.83333 10.6667 8.13181 10.6667 8.49999C10.6667 8.86818 10.3682 9.16666 10 9.16666H2.00001C1.63182 9.16666 1.33334 8.86818 1.33334 8.49999Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

export const MasPinesIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);

  const getTimesColor = () => {
    if (variant === variantColors.quaternary) {
      return getIconColorVariant('primary');
    }
  };

  return (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 16 17"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8.5" fill={color} r="7" />
      <path
        d="M7.39581 12V12.125H7.52081H8.48686H8.61186V12V9.10749H11.5H11.625V8.98249V8.01751V7.89251H11.5H8.61186V5V4.875H8.48686H7.52081H7.39581V5V7.89251H4.5H4.375V8.01751V8.98249V9.10749H4.5H7.39581V12Z"
        fill={getTimesColor()}
        stroke={getTimesColor()}
        strokeWidth="0.25"
      />
    </svg>
  );
};

export const InicioIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M8.53955 0.907986C8.81038 0.697338 9.18962 0.697338 9.46045 0.907986L16.2105 6.15799C16.3931 6.30008 16.5 6.51856 16.5 6.75V15C16.5 15.5967 16.2629 16.169 15.841 16.591C15.419 17.0129 14.8467 17.25 14.25 17.25H3.75C3.15326 17.25 2.58097 17.0129 2.15901 16.591C1.73705 16.169 1.5 15.5967 1.5 15V6.75C1.5 6.51856 1.60685 6.30008 1.78954 6.15799L8.53955 0.907986ZM3 7.11681V15C3 15.1989 3.07902 15.3897 3.21967 15.5303C3.36032 15.671 3.55109 15.75 3.75 15.75H14.25C14.4489 15.75 14.6397 15.671 14.7803 15.5303C14.921 15.3897 15 15.1989 15 15V7.11681L9 2.45015L3 7.11681Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

export const EquipoDePrimeraIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.834 18.167L15.834 1.83372C15.834 1.74167 15.7594 1.66705 15.6673 1.66705L4.33398 1.66705C4.24194 1.66705 4.16732 1.74167 4.16732 1.83372L4.16732 18.167C4.16732 18.2591 4.24194 18.3337 4.33398 18.3337L15.6673 18.3337C15.7594 18.3337 15.834 18.2591 15.834 18.167Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M15.834 10.0006L4.16732 10.0006"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M7.50122 10.0006C7.50122 11.3813 8.62051 12.5006 10.0012 12.5006C11.3819 12.5006 12.5012 11.3813 12.5012 10.0006C12.5012 8.61992 11.3819 7.50063 10.0012 7.50063C8.62051 7.50063 7.50122 8.61992 7.50122 10.0006Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M12.5012 1.66711L12.5012 4.00044C12.5012 4.04464 12.4837 4.08704 12.4524 4.11829C12.4211 4.14955 12.3788 4.16711 12.3346 4.16711L7.66789 4.16711C7.62368 4.16711 7.58129 4.14955 7.55004 4.11829C7.51878 4.08703 7.50122 4.04464 7.50122 4.00044L7.50122 1.66711"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M7.50122 18.3336L7.50122 16.0003C7.50122 15.956 7.51878 15.9137 7.55004 15.8824C7.58129 15.8511 7.62368 15.8336 7.66789 15.8336L12.3346 15.8336C12.3788 15.8336 12.4211 15.8511 12.4524 15.8824C12.4837 15.9137 12.5012 15.956 12.5012 16.0003L12.5012 18.3336"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
};

export const EquipoDeFutbol5 = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 20 14"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M8.27008 0.386004C8.00717 0.430955 7.92522 0.511267 7.76547 0.88044C7.58422 1.29944 7.48922 1.44439 7.24044 1.6818C6.49835 2.38999 5.23639 2.20349 3.94747 1.19522C3.73544 1.02933 3.49726 0.876265 3.41818 0.854978C3.16233 0.786226 2.93202 0.907017 2.6632 1.25093C1.55041 2.67453 0.804834 5.44333 0.985148 7.48252C1.0355 8.05223 1.09914 8.13781 1.59343 8.30082L1.9895 8.43144L1.91214 8.82866C1.82559 9.27294 1.85833 9.45344 2.05218 9.6006C2.239 9.74245 2.58436 9.77743 2.76839 9.67319C2.90696 9.59468 2.93643 9.54365 3.05882 9.17015L3.19506 8.75446L3.75147 8.90355L4.30788 9.05264L4.22811 9.46181C4.15681 9.8275 4.15839 9.8889 4.24285 10.0402C4.43847 10.3903 4.80717 10.4858 5.12352 10.2683C5.26193 10.1731 5.28847 10.1225 5.38098 9.77724L5.48412 9.39231L7.43428 9.90398C8.50686 10.1854 9.54632 10.4584 9.74412 10.5107L10.1038 10.6057L10.0315 10.9781C9.9177 11.5651 10.0175 11.7826 10.4544 11.8996C10.6161 11.943 10.7002 11.9349 10.8472 11.8622C11.0279 11.7727 11.0391 11.7551 11.1719 11.3491L11.3094 10.9287L11.876 11.0668L12.4426 11.2049L12.3554 11.5958C12.2553 12.0449 12.2926 12.2105 12.543 12.4289C12.6727 12.5419 12.724 12.561 12.887 12.5569C12.9924 12.5542 13.1491 12.5035 13.2353 12.4442C13.3796 12.345 13.4014 12.3018 13.5079 11.9043C13.5899 11.5985 13.642 11.4717 13.6864 11.4702C13.7209 11.469 13.9871 11.5186 14.2781 11.5804L14.807 11.6927L14.7024 12.0834C14.5833 12.5278 14.5952 12.7447 14.7501 12.9493C14.8998 13.1471 15.2905 13.2196 15.5164 13.0915C15.6685 13.0053 15.6795 12.9827 15.8479 12.4132L16.0222 11.824L16.1533 11.8297C17.1619 11.8735 18.2127 11.6506 18.769 11.275C19.0978 11.053 19.4049 10.6838 19.5199 10.3722C19.8274 9.53914 19.4474 8.4541 18.5708 7.66174C18.2383 7.36131 18.1622 7.3112 17.1134 6.70208C15.3217 5.66163 14.1385 4.79065 9.66103 1.21692C9.1537 0.81198 8.68005 0.45138 8.6085 0.415554C8.52398 0.373216 8.40543 0.362906 8.27008 0.386004ZM9.29693 2.43371C9.66492 2.7229 9.97724 2.97802 9.99106 3.00063C10.0049 3.02328 9.90087 3.17214 9.75999 3.33144C9.48684 3.6403 9.42583 3.8233 9.51134 4.07726C9.57169 4.25638 9.81832 4.44615 10.0106 4.46137C10.2583 4.48098 10.4262 4.38382 10.7058 4.05901L10.9627 3.76059L11.099 3.86622C11.6897 4.324 11.8875 4.50033 11.8654 4.54928C11.8515 4.58018 11.7936 4.68113 11.7367 4.77366C11.528 5.11346 11.7049 5.49984 12.12 5.61106C12.2982 5.65881 12.3718 5.65223 12.5131 5.57598C12.6088 5.52432 12.7278 5.4295 12.7777 5.36523C12.8275 5.3009 12.8734 5.24965 12.8795 5.25129C12.8856 5.25293 13.0081 5.34913 13.1516 5.46509C14.0223 6.16846 15.4746 7.13469 16.8133 7.90119C17.2026 8.1241 17.5945 8.37247 17.6842 8.45312C18.1384 8.86161 18.4699 9.47239 18.4258 9.81925C18.3807 10.1738 17.978 10.4379 17.2672 10.5791C16.6169 10.7083 15.9317 10.673 14.5956 10.4416C13.6852 10.2838 10.7551 9.56604 10.7715 9.50475C10.7779 9.48094 11.0945 9.05064 11.475 8.54852C11.8703 8.02695 12.1847 7.56926 12.2083 7.48093C12.262 7.28081 12.1937 7.04777 12.0439 6.91977C11.9786 6.86392 11.0632 6.3062 10.0098 5.68038C7.94483 4.45369 7.89345 4.43047 7.60761 4.59477C7.52924 4.6398 6.90175 5.38809 6.16625 6.31355L4.8636 7.95254L3.52358 7.59348L2.18352 7.23441L2.16697 7.09528C2.13076 6.79179 2.21845 5.80908 2.34119 5.14198C2.52109 4.16438 2.99703 2.84497 3.33882 2.37617L3.40796 2.28135L3.76032 2.51203C4.24434 2.82893 4.6893 3.02745 5.23774 3.17122C5.78903 3.31571 6.19688 3.33168 6.7341 3.22984C7.38493 3.10648 8.13871 2.60284 8.49203 2.05523C8.5476 1.96912 8.60091 1.90072 8.61051 1.9033C8.62011 1.90587 8.92898 2.14454 9.29693 2.43371ZM8.58651 6.21119C8.82015 6.35358 8.87352 6.40628 8.8409 6.46254C8.81824 6.50167 8.43546 6.99266 7.99032 7.55358L7.18096 8.57347L6.65339 8.43211L6.12582 8.29075L6.22919 8.15926C6.54401 7.75866 7.85382 6.11238 7.93441 6.01603C8.04212 5.88722 8.0672 5.89473 8.58651 6.21119ZM10.6634 7.45464C10.7558 7.52045 10.7552 7.52587 10.6389 7.67467C10.5734 7.7586 10.2905 8.13372 10.0104 8.50825L9.5009 9.18922L8.98873 9.06717C8.70704 9.00007 8.47279 8.93265 8.46817 8.91745C8.46356 8.9022 8.76319 8.5086 9.13396 8.04276C9.50474 7.57687 9.83831 7.15563 9.87516 7.10658L9.94223 7.01743L10.2554 7.20235C10.4277 7.30401 10.6113 7.41756 10.6634 7.45464Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

export const RankingIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 21 21"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.05 5.25H12.95C12.9964 5.25 13.0409 5.26844 13.0737 5.30126C13.1066 5.33408 13.125 5.37859 13.125 5.425V15.75H7.875V5.425C7.875 5.37859 7.89344 5.33408 7.92626 5.30126C7.95908 5.26844 8.00359 5.25 8.05 5.25V5.25Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3125"
      />
      <path
        d="M7.875 15.75H2.8C2.75359 15.75 2.70908 15.7316 2.67626 15.6987C2.64344 15.6659 2.625 15.6214 2.625 15.575L2.625 9.8C2.625 9.75359 2.64344 9.70908 2.67626 9.67626C2.70908 9.64344 2.75359 9.625 2.8 9.625H7.875L7.875 15.75Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3125"
      />
      <path
        d="M18.2 15.75H13.125V11.375H18.2C18.2464 11.375 18.2909 11.3934 18.3237 11.4263C18.3566 11.4591 18.375 11.5036 18.375 11.55V15.575C18.375 15.6214 18.3566 15.6659 18.3237 15.6987C18.2909 15.7316 18.2464 15.75 18.2 15.75V15.75Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3125"
      />
    </svg>
  );
};

export const PencilIcon = ({ className }: PropsWithClassName) => {
  return (
    <svg
      className={className}
      fill="none"
      height="19"
      viewBox="0 0 19 19"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12.384 2.68148C12.6755 2.39003 13.148 2.39003 13.4395 2.68148L17.1711 6.4131C17.4626 6.70456 17.4626 7.1771 17.1711 7.46856L7.4689 17.1708C7.32893 17.3107 7.1391 17.3894 6.94117 17.3894H3.20955C2.79737 17.3894 2.46323 17.0552 2.46323 16.643V12.9114C2.46323 12.7135 2.54186 12.5237 2.68182 12.3837L12.384 2.68148ZM3.95587 13.2206V15.8967H6.63203L15.5879 6.94083L12.9118 4.26467L3.95587 13.2206Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const MisPinesIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="19"
      viewBox="0 0 19 19"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_638_2474)">
        <path
          d="M9.49992 17.4167C13.8723 17.4167 17.4166 13.8724 17.4166 9.49999C17.4166 5.12762 13.8723 1.58333 9.49992 1.58333C5.12754 1.58333 1.58325 5.12762 1.58325 9.49999C1.58325 13.8724 5.12754 17.4167 9.49992 17.4167Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M9.5 12.9762V14.6458M11.875 6.72916C11.3327 6.18686 10.378 5.81003 9.5 5.78628L11.875 6.72916ZM7.125 11.875C7.63483 12.5558 8.58404 12.9437 9.5 12.9762L7.125 11.875ZM9.5 5.78628C8.455 5.75778 7.52083 6.23041 7.52083 7.52082C7.52083 9.89582 11.875 8.70832 11.875 11.0833C11.875 12.4379 10.716 13.0197 9.5 12.9762V5.78628ZM9.5 5.78628V4.35416V5.78628Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_638_2474">
          <rect fill="white" height="19" width="19" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MisMedallasIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M9.00049 1.5C6.51521 1.5 4.50049 3.51472 4.50049 6C4.50049 8.48528 6.51521 10.5 9.00049 10.5C11.4858 10.5 13.5005 8.48528 13.5005 6C13.5005 3.51472 11.4858 1.5 9.00049 1.5ZM3.00049 6C3.00049 2.68629 5.68678 0 9.00049 0C12.3142 0 15.0005 2.68629 15.0005 6C15.0005 9.31371 12.3142 12 9.00049 12C5.68678 12 3.00049 9.31371 3.00049 6Z"
        fill={color}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M11.7444 9.66651C12.155 9.61203 12.532 9.90074 12.5865 10.3114L13.494 17.1514C13.5319 17.4368 13.4029 17.7188 13.1622 17.8769C12.9215 18.035 12.6116 18.0413 12.3646 17.8931L9.00051 15.8746L5.63638 17.8931C5.38942 18.0413 5.07943 18.035 4.83873 17.8768C4.59802 17.7187 4.46912 17.4367 4.50704 17.1512L5.41454 10.3187C5.46907 9.90814 5.84615 9.61949 6.25675 9.67403C6.66736 9.72856 6.95601 10.1056 6.90148 10.5162L6.19884 15.8064L8.61463 14.3569C8.85215 14.2144 9.14887 14.2144 9.38638 14.3569L11.8024 15.8065L11.0995 10.5086C11.045 10.098 11.3337 9.72099 11.7444 9.66651Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

export const TorneosIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 19 20"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_638_2404)">
        <path
          clipRule="evenodd"
          d="M1.15986 12.7427C1.90219 12.0004 2.90901 11.5833 3.95882 11.5833H10.2922C11.342 11.5833 12.3488 12.0004 13.0911 12.7427C13.8335 13.485 14.2505 14.4919 14.2505 15.5417V17.125C14.2505 17.5622 13.896 17.9167 13.4588 17.9167C13.0216 17.9167 12.6672 17.5622 12.6672 17.125V15.5417C12.6672 14.9118 12.4169 14.3077 11.9715 13.8623C11.5261 13.4169 10.922 13.1667 10.2922 13.1667H3.95882C3.32893 13.1667 2.72484 13.4169 2.27944 13.8623C1.83404 14.3077 1.58382 14.9118 1.58382 15.5417V17.125C1.58382 17.5622 1.22938 17.9167 0.792155 17.9167C0.35493 17.9167 0.000488281 17.5622 0.000488281 17.125V15.5417C0.000488281 14.4919 0.417526 13.485 1.15986 12.7427Z"
          fill={color}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M7.12557 3.66668C5.81389 3.66668 4.75057 4.73 4.75057 6.04168C4.75057 7.35335 5.81389 8.41668 7.12557 8.41668C8.43725 8.41668 9.50057 7.35335 9.50057 6.04168C9.50057 4.73 8.43725 3.66668 7.12557 3.66668ZM3.16724 6.04168C3.16724 3.85555 4.93944 2.08334 7.12557 2.08334C9.3117 2.08334 11.0839 3.85555 11.0839 6.04168C11.0839 8.2278 9.3117 10 7.12557 10C4.93944 10 3.16724 8.2278 3.16724 6.04168Z"
          fill={color}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M15.0673 12.28C15.1766 11.8567 15.6084 11.6021 16.0318 11.7114C16.881 11.9307 17.6333 12.4257 18.1706 13.1189C18.708 13.8121 18.9999 14.664 19.0005 15.5411L19.0005 17.125C19.0005 17.5622 18.6461 17.9167 18.2089 17.9167C17.7716 17.9167 17.4172 17.5622 17.4172 17.125L17.4172 15.5423C17.4172 15.5422 17.4172 15.5423 17.4172 15.5423C17.4167 15.0161 17.2416 14.5048 16.9192 14.089C16.5968 13.6731 16.1454 13.376 15.6359 13.2445C15.2126 13.1351 14.958 12.7033 15.0673 12.28Z"
          fill={color}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M11.9002 2.78156C12.0086 2.358 12.4399 2.10255 12.8635 2.211C13.7149 2.429 14.4696 2.92419 15.0085 3.61849C15.5475 4.31279 15.84 5.16671 15.84 6.04563C15.84 6.92455 15.5475 7.77847 15.0085 8.47277C14.4696 9.16707 13.7149 9.66226 12.8635 9.88027C12.4399 9.98872 12.0086 9.73327 11.9002 9.3097C11.7917 8.88614 12.0472 8.45486 12.4707 8.34641C12.9816 8.21561 13.4344 7.9185 13.7578 7.50191C14.0811 7.08533 14.2566 6.57298 14.2566 6.04563C14.2566 5.51828 14.0811 5.00593 13.7578 4.58935C13.4344 4.17277 12.9816 3.87565 12.4707 3.74485C12.0472 3.6364 11.7917 3.20512 11.9002 2.78156Z"
          fill={color}
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_638_2404">
          <rect
            fill="white"
            height="19"
            transform="translate(0.000488281 0.5)"
            width="19"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PreguntasFrecuentesIcon = ({ variant }: IconProps) => {
  const color = getIconColorVariant(variant);
  return (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 17 17"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_638_2367)">
        <path
          clipRule="evenodd"
          d="M8.50041 2.12498C4.97959 2.12498 2.12541 4.97916 2.12541 8.49998C2.12541 12.0208 4.97959 14.875 8.50041 14.875C12.0212 14.875 14.8754 12.0208 14.8754 8.49998C14.8754 4.97916 12.0212 2.12498 8.50041 2.12498ZM0.70874 8.49998C0.70874 4.19676 4.19719 0.708313 8.50041 0.708313C12.8036 0.708313 16.2921 4.19676 16.2921 8.49998C16.2921 12.8032 12.8036 16.2916 8.50041 16.2916C4.19719 16.2916 0.70874 12.8032 0.70874 8.49998Z"
          fill={color}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M8.68332 5.68389C8.35358 5.62733 8.01446 5.6893 7.72602 5.85881C7.43759 6.02833 7.21846 6.29445 7.10743 6.61005C6.97762 6.97909 6.57322 7.17301 6.20418 7.04319C5.83515 6.91338 5.64123 6.50898 5.77104 6.13994C5.99309 5.50874 6.43135 4.97649 7.00822 4.63746C7.58509 4.29843 8.26333 4.17449 8.92282 4.28761C9.58231 4.40073 10.1805 4.7436 10.6114 5.2555C11.0422 5.76728 11.2781 6.415 11.2772 7.08398C11.2768 8.16798 10.4732 8.88384 9.89924 9.26645C9.59066 9.47216 9.28713 9.62343 9.06354 9.7228C8.95073 9.77294 8.85574 9.81098 8.78729 9.83706C8.75301 9.85012 8.72522 9.86024 8.70499 9.86743L8.68038 9.87605L8.67255 9.87872L8.66979 9.87965L8.6687 9.88002C8.66849 9.88009 8.66782 9.88031 8.44382 9.20833L8.66782 9.88031C8.29669 10.004 7.89555 9.80345 7.77184 9.43233C7.64821 9.06145 7.84843 8.66059 8.21909 8.53659L8.21818 8.5369C8.21825 8.53687 8.21831 8.53686 8.21909 8.53659L8.23039 8.53263C8.24128 8.52875 8.25914 8.52227 8.28297 8.5132C8.33073 8.495 8.40176 8.46664 8.48817 8.42824C8.66301 8.35053 8.89073 8.23616 9.11341 8.08771C9.60188 7.76207 9.86049 7.41563 9.86049 7.08333L9.86049 7.08228C9.86099 6.74772 9.74307 6.42378 9.52761 6.16783C9.31215 5.91188 9.01307 5.74045 8.68332 5.68389Z"
          fill={color}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M7.79224 12.0416C7.79224 11.6504 8.10937 11.3333 8.50057 11.3333H8.50765C8.89885 11.3333 9.21599 11.6504 9.21599 12.0416C9.21599 12.4328 8.89885 12.75 8.50765 12.75H8.50057C8.10937 12.75 7.79224 12.4328 7.79224 12.0416Z"
          fill={color}
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_638_2367">
          <rect
            fill="white"
            height="17"
            transform="translate(0.000488281)"
            width="17"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
